import { Button, Form, InputNumber } from 'antd';
import ItemsInput from 'components/ItemsInput';
import React, { useContext, useState } from 'react';
import { StepsContext } from '../Steps/StepsProvider';
import { STEPS } from '../constants';
import OrderFormItem from '../../components/OrderFormItem';
import Steps from '../Steps';
import { useIsCatering } from '../../utils/useIsCatering';
import Summary from './Summary';
import CustomItemOverlay from '../../../../components/ItemsInput/CustomItemOverlay';

function ItemsInfo() {
  const isCatering = useIsCatering();
  const { isActiveStep } = useContext(StepsContext);
  const isActive = isActiveStep(STEPS.ITEMS.id);
  const form = Form.useFormInstance();
  const merchant = form.getFieldValue('merchant');
  const items = form.getFieldValue('items');

  const getTotalCount = () => {
    if (!isActive && items?.length > 0) {
      let qty = 0;
      items.forEach((item) => {
        qty += item.qty;
      });
      return `(${qty})`;
    }
    return '';
  };

  return (
    <Steps.Step step={{ ...STEPS.ITEMS, title: `${STEPS.ITEMS.title} ${getTotalCount()}` }} summary={<Summary />}>
      <OrderFormItem
        name="headcount"
        label="Headcount"
        rules={[{ required: isCatering, message: 'Please select the merchant' }]}
        hidden={!isCatering}
      >
        <InputNumber addonAfter="People" min={1} />
      </OrderFormItem>
      <OrderFormItem name="items" fullWidth rules={[{ required: true }]}>
        <ItemsInput
          merchant={merchant}
          isEditMode={false}
          isCatering={isCatering}
        />
      </OrderFormItem>

    </Steps.Step>
  );
}

export default ItemsInfo;
